module.exports = __webpack_public_path__ + "images/movesense_instruction.webp";